module.exports = __webpack_public_path__ + "img/SendFox.76f68a16.png";